import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductService } from '../Services/product';
import { ProductFilterService } from '../Services/productfilter';
import { AlertService } from '../Services/alert';
import { AuthService } from '../Services/auth';
import { UserService } from '../Services/user';
import { CartService } from '../Services/cart';
import { MetaService } from '../Services/meta';
import { ImageUtils } from '../Services/imageutils';
import { LanguageService } from '../Services/lang';
import { Product } from '../Models/product';
import { Cart } from '../Models/cart';
import { Image } from '../Models/image';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';


@Component({
  selector: 'product-detail',
  templateUrl: '../Templates/product.detail.html',
  styleUrls: ['../Styles/product.detail.scss'],
})

export class ProductDetailComponent {

  product: Product;
  cart: Cart;
  id: number;
  related: Product[];
  modal_img: string = "";
  thumbs: Image[];
  active_thumb: number = 0;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private sanitizer: DomSanitizer,
              private meta: MetaService,
              private cartService: CartService,
              private productService: ProductService,
              private productfilter: ProductFilterService,
              private auth: AuthService,
              private userService: UserService,
              private alertService: AlertService,
              private modalService: NgbModal,
              private lang: LanguageService,
              private imageUtils: ImageUtils) {
  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.id = +params['id'];

      this.productService.get(this.id).subscribe(
        product => {
          this.product = product;

          this.meta.setDescription(this.product.description);

          this.meta.setTitle(this.product._brand.name + " " +
                              this.product._category.name)

          this.thumbs = [product.frontimage,
                         product.detailimage,
                         product.backimage];

          for (var i = 0; i < product.images.length; i++) {
            this.thumbs.push(product.images[i].image);
          }

          if (product.canHitSee()) {
            this.productService.see(product).subscribe();
          }

          this.productService.related(product, ['brand']).subscribe(
            related => {
              this.related = related;
            }
          );
        }
      );
    });

    this.cartService.getCart().subscribe(
      cart => { this.cart = cart }
    );

    // On user change, reload product to reflect new permissions
    this.auth.userChange$.subscribe(
      user => {
        this.productService.get(this.id).subscribe(
          product => { this.product = product; }
        );
      });

    // On lang change, reload product
    this.lang.langChange$.subscribe(
      lang => {
        this.productService.get(this.id).subscribe(
          product => { this.product = product; }
        );
      });
  }

  ngOnDestroy() {
    this.meta.reset();
  }

  inCart(product): boolean {
    return product._links.rm_from_cart != undefined;
  }

  canFollow(obj): boolean {

    try {
      return obj._links.follow != undefined;
    } catch(e) {
      return false;
    }
  }

  canUnFollow(obj): boolean {

    try {
      return obj._links.unfollow != undefined;
    } catch(e) {
      return false;
    }
  }

  addToCart(): void {

    this.cartService.addProduct(this.product).subscribe(
      data => {
        this.productService.get(this.product.id).subscribe(
          product => { this.product = product }
        )

        this.alertService.success("Product added to cart");
      },
      err => {
        if (err.name == "TimeoutError") {
          this.alertService.error("Your request has timed out. Try again later");
        } else {
          this.alertService.error("Could not add to cart");
        }
      }
    );
  }

  rmFromCart(): void {

    this.cartService.rmProduct(this.product).subscribe(
      data => {
        this.productService.get(this.product.id).subscribe(
          product => { this.product = product }
        )

        this.alertService.success("Product removed from cart");
      },
      err => {
        this.alertService.error("Could not remove from cart");
      }
    );
  }

  follow(): void {

    this.productService.follow(this.product).subscribe(
      product => {
        this.product = product;
        this.userService.following(product);
        this.alertService.success("Product added to wishlist");
      },
      err => {
        this.alertService.error("Could not add to wishlist");
      }
    );
  }

  unFollow(): void {

    this.productService.unFollow(this.product).subscribe(
      product => {
        this.product = product;
        this.userService.unfollowing(product);
        this.alertService.success("Product removed from wishlist");
      },
      err => {
        this.alertService.error("Could not remove from wishlist");
      }
    );
  }

  followUser(user): void {

    this.userService.follow(user).subscribe(
      user => {
        this.product._vendor = user;
        this.alertService.success("Following user");
      },
      err => {
        this.alertService.error("Could not follow");
      }
    );
  }

  unFollowUser(user): void {

    this.userService.unFollow(user).subscribe(
      user => {
        this.product._vendor = user;
        this.alertService.success("Not following user");
      },
      err => {
        this.alertService.error("Could not unfollow");
      }
    );
  }

  setActiveThumb(idx: number): void {
    this.active_thumb = idx;
  }

  showImage(modal, img) {

    this.modal_img = img;
    this.modalService.open(modal, { size: 'lg' });
  }

  showAllByVendor(vendor: any) {

    var vendor_name = vendor.first_name + " " + vendor.last_name;

    var vendor_id = +vendor.id;

    this.productfilter.addVocabValue('vendor', vendor_id, vendor_name);

    this.router.navigate(["/shop"], {queryParams: {vendor: vendor_id}});
  }

  canAsk(): boolean {

    try {
      return this.product._links.ask != undefined;
    } catch(e) {
      return false;
    }
  }

  public ask(msg: string): void {

    this.productService.ask(this.product, {'msg': msg}).subscribe(
      data => {
        this.alertService.success("Your question has been sent");
      },
      err => {
        this.alertService.error("Could not send your question");
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/product.detail.ts